import { FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection } from '@festina/unitlink-general-types/unitlink/hooks/FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection'

export const useFetchSpecificTradeCycle =
  FundPriceSetsService_fundPriceSetsServiceGetFundPriceCollection.useSuspenseQuery
